import { DefaultDateField } from "../../../../common/components/forms/inputs/dateField/DefaultDateField";
import { DefaultFormSelectField } from "../../../../common/components/forms/inputs/dropdown/DefaultFormSelectField";
import { DefaultInputField } from "../../../../common/components/forms/inputs/InputField/DefaultInputField";
import { TransferStatus } from "../../../../common/enums";
import styles from "./InventoryTransferHeaderFields.module.scss";

interface IHeaderFieldsProps {
  disabled: boolean;
}

const STATUS_OPTIONS = [
  { id: TransferStatus.Planned, name: "Планирана" },
  { id: TransferStatus.Completed, name: "Завършена" },
];

export const InventoryTransferHeaderFields = ({ disabled }: IHeaderFieldsProps) => {
  return (
    <div className={styles.grid}>
      <DefaultDateField
        name="deliveryDate"
        label="Дата на доставка"
        required
        disabled={disabled}
        width="100%"
      />
      <DefaultFormSelectField
        name="status"
        label="Статус"
        required
        disabled={disabled}
        options={STATUS_OPTIONS}
        filter={false}
        includeId={false}
        width="100%"
      />
      <DefaultInputField
        name="supplier"
        label="Доставчик"
        placeholder="Незадължително"
        type="text"
        disabled={disabled}
        width="100%"
      />
    </div>
  );
};
